import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sendingShipmentNotificationTitle: {
    description: 'sendingShipmentNotificationTitle.sendingShipmentNotificationTitle',
    defaultMessage: 'Processing...',
    id: 'goGtpL',
  },
  sendingShipmentNotificationContent: {
    description: 'sendingShipmentNotificationContent.sendingShipmentNotificationContent',
    defaultMessage: 'Sending Shipment Notification',
    id: '4iI0aH',
  },
  shipmentNotificationSuccessTitle: {
    description: 'sendingShipmentNotificationContent.shipmentNotificationSuccessTitle',
    defaultMessage: 'Processed',
    id: 'tNMA3T',
  },
  shipmentNotificationSuccessContent: {
    description: 'sendingShipmentNotificationContent.shipmentNotificationSuccessContent',
    defaultMessage: 'Shipment Notification Sent!',
    id: 'Ifoh4G',
  },
  shipmentNotificationErrorTitle: {
    description: 'sendingShipmentNotificationContent.shipmentNotificationErrorTitle',
    defaultMessage: 'Error',
    id: 'iQyxNE',
  },
  shipmentNotificationErrorContent: {
    description: 'sendingShipmentNotificationContent.shipmentNotificationErrorContent',
    defaultMessage: 'Shipment Notification Failed',
    id: 'DN+M++',
  },
});
